
import { AppService } from "app/services/app.service";
import { Observable } from "rxjs";

export abstract class AbRelatorioPortaria extends AppService {
  abstract getRelatorioPortaria(filter: String): Observable<any>;
  abstract getRelatorio(filter: string): Observable<any>;
}